import { Input, InputField } from "../../../../../ui/input";
import type { FieldControlProps } from "../fieldTypes";

const TextField = ({
  field,
  value,
  onChange,
  disabled,
  invalid,
  onBlur,
}: FieldControlProps) => (
  <Input size="md" isDisabled={disabled} isInvalid={invalid}>
    <InputField
      value={typeof value === "string" ? value : ""}
      onChangeText={onChange}
      onBlur={onBlur}
      accessibilityLabel={field.label}
    />
  </Input>
);

export default TextField;
